import { createSelector } from 'reselect';

const getMe = ({ meReducer }) => meReducer;

export const shouldFetchRegisteredSessionsSelector = createSelector(
    [getMe],
    ({ registeredSessionIds }) => registeredSessionIds === null
);

export const meIdSelector = createSelector(getMe, ({ me }) => me?.id);
